/**
 * Territory Identity same-app invalidation bus.
 *
 * A successful AUTHORITATIVE Territory Identity mutation (name SAVE / merge
 * RECONCILE) in the Dashboard notifies same-page consumers (the My Territories
 * list + detail header, which read the name from the shared `useTerritoryPreviews`
 * batch) to re-resolve from the backend — so a renamed territory never stays
 * stale on its own slots WITHOUT a page reload, WITHOUT polling, and WITHOUT
 * optimistic client authority (consumers always re-read the backend).
 *
 * Transport is a plain `window` CustomEvent; no shared mutable state, safe across
 * mounts and SSR (no-op without a DOM). Only SUCCESSFUL mutations emit.
 */
const EVENT = "thegrid:territory-identity-mutation";

/** Announce a confirmed authoritative Territory Identity mutation (name/merge). */
export function emitTerritoryIdentityMutation(): void {
  if (typeof window === "undefined" || typeof CustomEvent === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVENT));
}

/** Subscribe to authoritative Territory Identity mutations. Returns an unsubscribe. */
export function onTerritoryIdentityMutation(cb: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  const handler = () => cb();
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
